import React from 'react';

export default function MiniIconsMenu({ icon, title }) {
    return (
        <>
            <h4 id="miniIconMenu">{title}</h4>
        </>
    );
}
